export const COLLAPSED_STYLE = { height: '0', overflow: 'hidden' };
